import { render, staticRenderFns } from "./KdIcon.vue?vue&type=template&id=4cb8f9ee"
import script from "./KdIcon.vue?vue&type=script&lang=ts"
export * from "./KdIcon.vue?vue&type=script&lang=ts"
import style0 from "./KdIcon.vue?vue&type=style&index=0&id=4cb8f9ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_css-loader@6.11.0_lodash@4.17.21_prettier@2.2.1__svvz7rxqjs6qp55qupdfm65wwi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports